import { withInstall } from '@ll-plus/utils'

import FlexSplitLayout from './src/flex-split-layout.vue'

export const LlFlexSplitLayout = withInstall(FlexSplitLayout)
export default LlFlexSplitLayout
export * from './src/flex-split-layout'

declare module 'vue' {
  export interface GlobalComponents {
    LlFlexSplitLayout: typeof FlexSplitLayout
  }
}
